import React, { useState, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../Context/AppContext';
import configData from '../../../config.json';
import Achievements from './Modals/Achievements';
import ImageIcon from './Modals/ImageIcon';
import iconUser from '../../../Assets/img/userIcon.jpg';
import './UserInfo.css';

const UserInfo = (props) => {
    const { checkUserSession } = useContext(AppContext);
    const { token, userId } = checkUserSession();

    const [show, SetShow] = useState(false);
    const [showAchievents, SetShowAchievents] = useState(false);
    const [badgeSelected, setBadge] = useState('');
    const [imageHash, imageHashChange] = useState(Date.now());

    const [data, changeData] = useState({
        file: null,
    });

    function setShowModal(visible) {
        SetShow(visible);
    }
    function SetShowAchieventsModal(visible) {
        SetShowAchievents(visible);
    }

    function setBadgeModal(section) {
        setBadge(section);
    }

    function clickButtonAchievements() {
        setShowModal(true);
    }

    const changeHandler = (event) => {
        const AllProps = { ...data };
        AllProps.file = event.target.files[0];
        changeData(AllProps);

        // Create an object of formData
        const formData = new FormData();
        formData.append('userId', userId);
        formData.append('image', AllProps.file);

        const url = `${configData.SERVER_URL_IMGUpload}`;
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            },
        };
        axios
            .post(url, formData, config)
            .then((response) => {
                if (response.status === 201) {
                    props.getCustomerProfileInformation();
                    const AllProps = { ...data };
                    AllProps.file = null;
                    changeData(AllProps);
                    imageHashChange(Date.now());

                    alert('Image uploaded correctly');
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    return (
        <article className="userInfo">
            <div className="userInfo__image">
                <div
                    alt="Profile"
                    className="image__profile"
                    style={{
                        '--imgProfileUrl': `url(${
                            props.AllState.profile.pictureFileName
                                ? `${configData.SERVER_URL_IMG}/media/profile/${props.AllState.profile.pictureFileName}?${imageHash}`
                                : iconUser
                        })`,
                    }}
                >
                    {props.PublicProfile !== 1 && (
                        <div className="image__input">
                            <input
                                type="file"
                                size="35"
                                onChange={changeHandler}
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="userInfo__info">
                {props.PublicProfile !== 1 && (
                    <h5 className="heading-5 BlueDarkText">Hello</h5>
                )}
                <div className="info__name">
                    <h1 className="heading-1 BlueDarkText">
                        {props.AllState.profile.firstName}{' '}
                        {props.AllState.profile.lastName}
                    </h1>
                    {props.PublicProfile !== 1 &&
                        props.NonSubscriber === false && (
                            <div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    id="Group_839"
                                    width="35"
                                    height="35"
                                    viewBox="0 0 24 24"
                                    fill="#78ccf6"
                                    className="svgRank"
                                >
                                    <g id="flat">
                                        <path
                                            id="Path_453"
                                            d="M48.921 36l.747-1.446-1.068-1.229.376-1.582-1.338-.936-.019-1.625-1.525-.591-.408-1.574-1.625-.217-.774-1.432-1.627.178-1.1-1.2-1.536.562L37.668 24l-1.357.908-1.536-.562-1.1 1.2-1.627-.178-.773 1.432-1.623.214-.408 1.574-1.525.591-.019 1.628-1.338.936.376 1.582-1.071 1.229.748 1.446-.747 1.446 1.071 1.229-.376 1.582 1.338.936.019 1.625 1.525.591.408 1.574 1.622.214.774 1.432 1.627-.178 1.1 1.2 1.536-.562 1.356.911 1.357-.908 1.536.562 1.1-1.2 1.627.178.774-1.432 1.623-.214.408-1.574 1.525-.591.019-1.625 1.338-.936-.375-1.585 1.071-1.229z"
                                            className="cls-1"
                                            transform="translate(-25.668 -24)"
                                        />
                                        <ellipse
                                            id="Ellipse_894"
                                            cx="9.58"
                                            cy="9.493"
                                            fill="#2c414c"
                                            rx="9.58"
                                            ry="9.493"
                                            transform="translate(2.42 2.507)"
                                        />
                                        <path
                                            id="Path_454"
                                            d="M104.312 112.478a8.541 8.541 0 0 1-.87-.046l.087-.819a7.685 7.685 0 0 0 .783.041zm.87-.043l-.085-.82a7.593 7.593 0 0 0 .775-.119l.171.806a8.451 8.451 0 0 1-.861.132zm-2.6-.138a8.4 8.4 0 0 1-.842-.224l.258-.783a7.525 7.525 0 0 0 .757.2zm4.3-.216l-.256-.784a7.494 7.494 0 0 0 .732-.277l.338.753a8.34 8.34 0 0 1-.815.308zm-5.958-.319a8.375 8.375 0 0 1-.775-.393l.418-.713a7.515 7.515 0 0 0 .7.354zm7.55-.38l-.416-.714a7.544 7.544 0 0 0 .658-.422l.489.667a8.379 8.379 0 0 1-.731.469zm-9.055-.484a8.372 8.372 0 0 1-.676-.544l.558-.611a7.54 7.54 0 0 0 .609.49zm10.464-.526l-.556-.613a7.525 7.525 0 0 0 .556-.548l.617.552a8.354 8.354 0 0 1-.614.609zm-11.755-.628a8.293 8.293 0 0 1-.548-.67l.674-.484a7.5 7.5 0 0 0 .493.6zm12.922-.649l-.672-.486a7.455 7.455 0 0 0 .429-.65l.72.414a8.283 8.283 0 0 1-.476.722zm-13.944-.745a8.229 8.229 0 0 1-.4-.769l.761-.335a7.4 7.4 0 0 0 .356.692zm14.818-.744l-.76-.337a7.358 7.358 0 0 0 .283-.723l.791.256a8.151 8.151 0 0 1-.314.8zm-15.525-.83a8.16 8.16 0 0 1-.224-.834l.815-.17a7.314 7.314 0 0 0 .2.75zm16.066-.807l-.814-.172a7.363 7.363 0 0 0 .123-.766l.828.087a8.17 8.17 0 0 1-.134.851zm-16.424-.879a8.268 8.268 0 0 1-.044-.851v-.009h.833v.009a7.451 7.451 0 0 0 .04.767zm16.608-.834h-.833v-.017a7.474 7.474 0 0 0-.04-.775l.828-.086a8.282 8.282 0 0 1 .045.86zm-15.778-.8l-.828-.086a8.177 8.177 0 0 1 .136-.852l.814.171a7.352 7.352 0 0 0-.119.766zm14.784-.758a7.318 7.318 0 0 0-.2-.75l.792-.254a8.152 8.152 0 0 1 .225.833zM97.2 101.94l-.792-.255a8.173 8.173 0 0 1 .313-.8l.76.336a7.353 7.353 0 0 0-.282.724zm13.975-.717a7.388 7.388 0 0 0-.357-.691l.721-.413a8.2 8.2 0 0 1 .4.768zm-13.336-.7l-.72-.413a8.287 8.287 0 0 1 .476-.722l.673.485a7.444 7.444 0 0 0-.428.65zm12.552-.644a7.509 7.509 0 0 0-.494-.6l.619-.551a8.356 8.356 0 0 1 .548.669zm-11.629-.608l-.618-.552a8.378 8.378 0 0 1 .616-.609l.557.612a7.551 7.551 0 0 0-.556.551zm10.58-.544a7.526 7.526 0 0 0-.609-.489l.49-.666a8.371 8.371 0 0 1 .677.543zm-9.415-.493l-.489-.667a8.4 8.4 0 0 1 .731-.47l.416.714a7.52 7.52 0 0 0-.658.423zm8.149-.419a7.549 7.549 0 0 0-.7-.353l.339-.752a8.384 8.384 0 0 1 .776.392zm-6.793-.356l-.339-.753a8.346 8.346 0 0 1 .814-.309l.257.784a7.526 7.526 0 0 0-.733.28zm5.363-.275a7.556 7.556 0 0 0-.757-.2l.173-.806a8.415 8.415 0 0 1 .842.223zm-3.873-.2l-.172-.806a8.443 8.443 0 0 1 .861-.133l.085.82a7.543 7.543 0 0 0-.775.12zm2.342-.119a7.7 7.7 0 0 0-.784-.04V96a8.54 8.54 0 0 1 .869.045z"
                                            className="cls-1"
                                            transform="translate(-92.326 -92.239)"
                                        />
                                        <ellipse
                                            id="Ellipse_895"
                                            cx="6.237"
                                            cy="6.15"
                                            className="cls-1"
                                            rx="6.237"
                                            ry="6.15"
                                            transform="translate(5.763 5.85)"
                                        />
                                    </g>
                                </svg>
                                <h6 className="heading-6">
                                    {props.AllState.profile.rankLevelCode}
                                </h6>
                            </div>
                        )}
                </div>
                {props.NonSubscriber !== true && (
                    <>
                        <div className="info__level">
                            <p className="paragraph-2 BlueDarkText">
                                {props.AllState.profile.rank}{' '}
                                <span>{props.AllState.profile.rankLevel}</span>
                            </p>
                            {props.PublicProfile !== 1 && (
                                <div className="level__back">
                                    <section className="paragraph-3">
                                        {props.AllState.profile.customerLevel?.toUpperCase()}
                                    </section>
                                </div>
                            )}
                        </div>
                        <div className="info__achievements">
                            {props.achievementsLoading ? (
                                <div className="lds-ellipsis">
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                </div>
                            ) : (
                                props.AllState.profile.latestAchievements
                                    ?.length > 0 &&
                                props.AllState.profile.latestAchievements.map(
                                    (item, index) => (
                                        <ImageIcon
                                            key={`BadgetSVG${item.id}`}
                                            index={index}
                                            name={item.id}
                                            type="achievements"
                                            value={
                                                props.AllState.userProgress
                                                    .goalsCompleted
                                            }
                                            item={item}
                                        />
                                    )
                                )
                            )}
                            <button
                                onClick={() => clickButtonAchievements()}
                                type="button"
                            >
                                My achievements
                            </button>
                        </div>
                    </>
                )}
            </div>

            {props.NonSubscriber !== true && show && (
                <Achievements
                    show={show}
                    showAchievents={showAchievents}
                    setShowError={setShowModal}
                    AllState={props.AllState}
                    AllStateChange={props.AllStateChange}
                    SetShow={SetShow}
                    SetShowAchieventsModal={SetShowAchieventsModal}
                    setBadgeModal={setBadgeModal}
                    badgeSelected={badgeSelected}
                    setShowModal={setShowModal}
                />
            )}
        </article>
    );
};

export default UserInfo;
